"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const companyService = {
  getCompanies: function (options) {
    return api.get("/Companies", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getCompany: function (id) {
    return api.get(`/Companies/${id}/information`, WithToken.headersToken({}, configuration.cookieName));
  },
  setCompaniesToOwnership: function (id, options) {
    return api.put(`/OwnershipAreas/${id}/Companies`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  updateCompany: function (options) {
    return api.put(`/Companies/${options.id}`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  createOwnershipArea: function (options) {
    return api.post(`/OwnershipAreas`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  createCompany: function (options) {
    return api.post("/Companies", {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  transferUnitsToCompany: function (id, units) {
    return api.put(`/Companies/${id}/TransferUnits`, units, WithToken.headersToken({}, configuration.cookieName));
  },
  enteringCompany: function (id) {
    return api.put(`/Companies/${id}/Entering`, {}, WithToken.headersToken({}, configuration.cookieName));
  },
  downloadCompanyInfo: function (id, options) {
    return api.get(
      `/Companies/${id}/information/Download`,
      WithToken.headersToken({ params: options, responseType: "blob" }, configuration.cookieName)
    );
  },
};

export default companyService;
